import { render } from "./TermsAndConditionsPage.vue?vue&type=template&id=ae6fa148&scoped=true"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=js"

import "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=ae6fa148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6fa148"]])

export default __exports__